import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "rc-slider/assets/index.css";
import { Handle } from "rc-slider";
import React from "react";
import { StyledRange, StyledTooltip } from "./styles";
export var markText = function markText(value) {
  return "".concat(value / 10, " cm");
};
var markTextStyle = {
  transform: "none",
  left: "unset"
};
export var parseIntValue = function parseIntValue(value) {
  if (typeof value === "number") {
    return value;
  }

  return parseInt(value.replace(/width-|height-/, ""), 10); // "width-700" -> 700
};

var parseRCRangeValue = function parseRCRangeValue(values, defaultValues) {
  var selectedIntValues = values.filter(function (v) {
    return v.selected;
  }).map(function (v) {
    return parseIntValue(v.slug);
  });

  if (!selectedIntValues.length) {
    return defaultValues;
  }

  var from = Math.min.apply(Math, _toConsumableArray(selectedIntValues));
  var to = Math.max.apply(Math, _toConsumableArray(selectedIntValues));
  return [from, to];
};

var Range = function Range(_ref) {
  var values = _ref.values,
      onChange = _ref.onChange;
  var byIntValues = values.reduce(function (acc, cur) {
    return _objectSpread({}, acc, _defineProperty({}, parseIntValue(cur.slug), _objectSpread({}, cur, {
      intValue: parseIntValue(cur.slug)
    })));
  }, {});
  var intValues = Object.values(byIntValues).map(function (v) {
    return v.intValue;
  });
  var min = Math.min.apply(Math, _toConsumableArray(intValues));
  var max = Math.max.apply(Math, _toConsumableArray(intValues));
  var marks = intValues.reduce(function (acc, cur) {
    var mark;

    if (cur === min || cur === max) {
      mark = {
        label: markText(cur),
        style: markTextStyle
      };
    }

    return _objectSpread({}, acc, _defineProperty({}, cur, mark));
  }, {});

  var onChangeHandler = function onChangeHandler(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        from = _ref3[0],
        to = _ref3[1];

    var isFullRange = from === min && to === max;

    if (isFullRange) {
      onChange(null);
      return;
    }

    var intValuesWithinRange = intValues.filter(function (v) {
      return v >= from && v <= to;
    });
    var slugValuesArr = intValuesWithinRange.map(function (v) {
      var _byIntValues$v;

      return (_byIntValues$v = byIntValues[v]) === null || _byIntValues$v === void 0 ? void 0 : _byIntValues$v.slug;
    });
    onChange(slugValuesArr);
  };

  var handleTooltip = function handleTooltip(props) {
    var value = props.value,
        dragging = props.dragging,
        index = props.index,
        rest = _objectWithoutProperties(props, ["value", "dragging", "index"]);

    return React.createElement(Handle, _extends({
      className: "custom-tooltip",
      vertical: false,
      offset: 0,
      key: index
    }, rest), dragging && React.createElement(StyledTooltip, null, "".concat(value / 10, " cm")));
  };

  return React.createElement(StyledRange, {
    min: min,
    max: max,
    onChange: onChangeHandler,
    marks: marks,
    step: null,
    defaultValue: [min, max],
    value: parseRCRangeValue(values, [min, max]),
    handle: handleTooltip
  });
};

export { Range };